export default "__VITE_ASSET__CN$kCxuH__"